import { useDataFetch } from "./Use-data-fetch";


/**
 * Hook personalizado para obtener la lista de países
 */
export const useCountries = (userId) => {  
  const { getData } = useDataFetch();

  const query = getData(
    ['countries'],
    '/product/countries-available/user-dash/' + userId,
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60, // 1 hora
      gcTime: 1000 * 60 * 60 * 2 // 2 horas
    }
  );


  
  const countries = query.data?.country?.country_id ? [{
    country_id: query.data.country.country_id,
    name: query.data.country.name,
    shippingCost: query.data.country.shippingCost??0,
  }] : [];

  return {
    countries,
    ...query
  };
};

/**
 * Hook personalizado para obtener las provincias por país
 */
export const useProvinces = (countryId) => {
  const { getData } = useDataFetch();

  const query = getData(
    ['provinces', countryId],
    countryId ? `/address/provinces/by-country?country_id=${countryId}` : '',
    {
      enabled: !!countryId,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 30, // 30 minutos
      gcTime: 1000 * 60 * 60 // 1 hora
    }
  );

  const provinces = query.data?.data?.provinces || [];

  return {
    provinces,
    ...query
  };
};

/**
 * Hook personalizado para obtener las ciudades por provincia
 */
export const useCities = (provinceId) => {
  const { getData } = useDataFetch();

  const query = getData(
    ['cities', provinceId],
    provinceId ? `/address/cities/by-province?province_id=${provinceId}` : '',
    {
      enabled: !!provinceId,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 30, // 30 minutos
      gcTime: 1000 * 60 * 60 // 1 hora
    }
  );

  const cities = query.data?.data?.cities || [];

  return {
    cities,
    ...query
  };
};
